import React from 'react';
import { useStyles } from './styles';

const FormFooter = React.memo(() => {
    const classes = useStyles();
    return (
        <div className={classes.footer}>
            Note that you can start, leave, and return to complete the form before submitting it to
            us.
        </div>
    );
});
export default FormFooter;
